//PHONE NUMBERS
export const WHATS_APP_LINK = "555193133726";
export const WHATS_APP_TEXT = "51 93133 726";
